import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { ComposableMap, Geographies, Geography, Marker } from 'react-simple-maps';

import ThreatGeoMarker from 'components/ThreatGeoMarker';
import { countryCoordinates } from './coordinates';
import featureJSON from './features.json';
import './styles.scss';

function mapCountriesForMarker(countries) {
  const severityOrder = ['critical', 'high', 'medium', 'low'];

  return countries.map(({ country, code, severity }) => {
    // Find coordniates
    const coordinates = countryCoordinates.find((countryCoordinate) => countryCoordinate.code === code)?.coordinates;

    // Find the maximum severity value and its type based on priority
    const { maxSeverity, maxType } = severityOrder.reduce(
      (acc, type) => {
        if (severity[type] > acc.maxSeverity) {
          return { maxSeverity: severity[type], maxType: type };
        }
        return acc;
      },
      { maxSeverity: -1, maxType: '' },
    );

    // Determine size based on maxSeverity value
    let size = 'xs';
    if (maxSeverity >= 60) size = 'lg';
    else if (maxSeverity >= 40) size = 'md';
    else if (maxSeverity >= 20) size = 'sm';

    return {
      country,
      coordinates,
      severity: maxType,
      size,
    };
  });
}

const ThreatMap = ({ countries }) => {
  const markers = mapCountriesForMarker(countries);

  return (
    <Box className="threat-map" sx={{ height: 630, maxHeight: 630, width: 1280, maxWidth: 1280 }}>
      <ComposableMap viewBox="0, 0, 880, 550">
        <Geographies geography={featureJSON}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                style={{ default: { outline: 'none' }, hover: { outline: 'none' }, pressed: { outline: 'none' } }}
                key={geo.rsmKey}
                geography={geo}
                fill="#1D043A"
                stroke="#ffffff7f"
              />
            ))
          }
        </Geographies>
        {markers.map((marker) => (
          <Marker key={marker.country} coordinates={marker.coordinates}>
            <ThreatGeoMarker severity={marker.severity} size={marker.size} country={marker.country} />
          </Marker>
        ))}
      </ComposableMap>
    </Box>
  );
};

ThreatMap.propTypes = {
  countries: PropTypes.array.isRequired,
};

export default ThreatMap;
